import { render, staticRenderFns } from "./TrendingProductsCarousel.sync.vue?vue&type=template&id=f076fec2&scoped=true&"
import script from "./TrendingProductsCarousel.sync.vue?vue&type=script&lang=js&"
export * from "./TrendingProductsCarousel.sync.vue?vue&type=script&lang=js&"
import style0 from "./TrendingProductsCarousel.sync.vue?vue&type=style&index=0&id=f076fec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f076fec2",
  null
  
)

export default component.exports